import { render, staticRenderFns } from "./TemplateMessageSelector.vue?vue&type=template&id=07411a46&scoped=true"
import script from "./TemplateMessageSelector.vue?vue&type=script&lang=js"
export * from "./TemplateMessageSelector.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessageSelector.vue?vue&type=style&index=0&id=07411a46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07411a46",
  null
  
)

export default component.exports